import { cn } from '@/lib/cn'
import { useT } from '@/i18n'

/**
 * SKILL §11: nuqta + matn. Faqat rang YETARLI EMAS (rang ko'rmaslik + a11y).
 */
export type StatusKind =
  | 'active'
  | 'pending'
  | 'banned'
  | 'blocked'
  | 'deleted'
  | 'review'
  | 'suspended'
  | 'open'
  | 'approved'
  | 'rejected'
  | 'expired'
  // A18.06 four-eyes holat mashinasi (migratsiya 000076: ck_fe_status)
  | 'executed'
  | 'cancelled'

const TONE: Record<StatusKind, { dot: string; text: string; bg: string }> = {
  active: { dot: 'bg-success', text: 'text-success', bg: 'bg-success-subtle' },
  approved: { dot: 'bg-success', text: 'text-success', bg: 'bg-success-subtle' },
  open: { dot: 'bg-success', text: 'text-success', bg: 'bg-success-subtle' },
  pending: { dot: 'bg-warning', text: 'text-warning', bg: 'bg-warning-subtle' },
  suspended: { dot: 'bg-warning', text: 'text-warning', bg: 'bg-warning-subtle' },
  banned: { dot: 'bg-danger', text: 'text-danger', bg: 'bg-danger-subtle' },
  blocked: { dot: 'bg-danger', text: 'text-danger', bg: 'bg-danger-subtle' },
  rejected: { dot: 'bg-danger', text: 'text-danger', bg: 'bg-danger-subtle' },
  review: { dot: 'bg-info', text: 'text-info', bg: 'bg-info-subtle' },
  deleted: { dot: 'bg-muted', text: 'text-muted', bg: 'bg-muted-subtle' },
  expired: { dot: 'bg-muted', text: 'text-muted', bg: 'bg-muted-subtle' },
  executed: { dot: 'bg-success', text: 'text-success', bg: 'bg-success-subtle' },
  cancelled: { dot: 'bg-muted', text: 'text-muted', bg: 'bg-muted-subtle' },
}

export function StatusBadge({
  status,
  label,
  className,
}: {
  status: StatusKind
  /** Katalogda yo'q holat uchun aniq matn. */
  label?: string
  className?: string
}) {
  const t = useT()
  const tone = TONE[status]
  const text = label ?? t.status[status] ?? status

  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-sm px-1.5 py-0.5 text-xs font-medium whitespace-nowrap',
        tone.bg,
        tone.text,
        className,
      )}
    >
      <span className={cn('h-1.5 w-1.5 shrink-0 rounded-full', tone.dot)} aria-hidden />
      {text}
    </span>
  )
}

/**
 * Teg — kategoriya (ko'p, ixtiyoriy, kulrang). Badge'dan farqi SKILL §11 da.
 */
export function Tag({ children, className }: { children: React.ReactNode; className?: string }) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-sm border border-border-subtle bg-surface-3',
        'px-1.5 py-0.5 text-xs text-secondary whitespace-nowrap',
        className,
      )}
    >
      {children}
    </span>
  )
}
